export {default as it} from './it'
export {default as en} from './en'



// WEBPACK FOOTER //
// ./src/i18n/index.js